/**
 * Estados del procesamiento de solicitudes de webhook de Bitrix
 */
export enum BitrixRequestStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  Success = 'Success',
  Failed = 'Failed'
}

/**
 * Tipo de solicitud de webhook de Bitrix
 */
export enum BitrixRequestType {
  Inbound = 'Inbound',   // Webhook recibido desde Bitrix
  Outbound = 'Outbound'  // Petición enviada hacia Bitrix
}

/**
 * Interfaz para listado de solicitudes de webhook de Bitrix
 */
export interface BitrixWebhookRequest {
  id: number;
  leadId: string;
  requestType: BitrixRequestType;
  requestDate: Date | string;
  processedDate?: Date | string | null;
  status: BitrixRequestStatus;
  errorMessage?: string | null;
  failureStep?: string | null;
  retryCount: number;
  enrollmentId?: number | null;
  participantId?: number | null;
  projectMnemonic?: string | null;
  participantEmail?: string | null;
  participantName?: string | null;
  lastRetryDate?: Date | string | null;
  processingTimeMs?: number | null;
  // Campos para Outbound
  outboundAction?: string | null;
}

/**
 * Interfaz detallada para una solicitud de webhook de Bitrix
 */
export interface BitrixWebhookRequestDetail {
  id: number;
  leadId: string;
  requestType: BitrixRequestType;
  requestDate: Date | string;
  processedDate?: Date | string | null;
  status: BitrixRequestStatus;
  rawLeadData?: string | null;
  errorMessage?: string | null;
  errorDetails?: string | null;
  failureStep?: string | null;
  retryCount: number;
  enrollmentId?: number | null;
  participantId?: number | null;
  projectMnemonic?: string | null;
  participantEmail?: string | null;
  participantName?: string | null;
  lastRetryDate?: Date | string | null;
  httpRequestInfo?: string | null;
  processingTimeMs?: number | null;
  completedStep?: string | null;
  // Campos para Outbound
  outboundAction?: string | null;
  outboundResponse?: string | null;
  outboundStatusId?: string | null;
  // Logs de procesamiento
  processingLogs?: string | null;
  // Auditoría
  createdAt: Date | string;
  createdBy?: string | null;
  updatedAt: Date | string;
  updatedBy?: string | null;
}

/**
 * Interfaz para filtrar solicitudes
 */
export interface BitrixWebhookRequestFilter {
  status?: BitrixRequestStatus;
  projectMnemonic?: string;
  participantEmail?: string;
  fromDate?: Date | string;
  toDate?: Date | string;
  failureStep?: string;
}

/**
 * Interfaz para estadísticas de solicitudes
 */
export interface BitrixWebhookStats {
  totalRequests: number;
  pendingRequests: number;
  processingRequests: number;
  successRequests: number;
  failedRequests: number;
  successRate: number;
  commonErrors: { [key: string]: number };
  topProjects: { [key: string]: number };
}

